import Teacher from "./teacher/teacher.store";
import Staff from "./staff/staff.store";

export default {
  modules: { Teacher, Staff },
};
